import { Controller } from '@hotwired/stimulus'

export default class BannerController extends Controller {
  static targets = ['container']
  static values = { cookieName: String }

  close () {
    this.#hide(this.containerTarget)
    if (this.cookieNameValue) this.#setDismissedBannerCookie()
  }

  #hide (target) {
    target.classList.add('hidden')
  }

  #setDismissedBannerCookie () {
    const key = this.#cookieKey()
    document.cookie = `${key}=true; path=/; max-age=31536000` // 1 year
  }

  #cookieKey () {
    return `banner_closed_${this.cookieNameValue || 'default'}`
  }
}
